import cn from 'classnames';
import { useState } from 'react';

import MenuItem from './MenuItem.jsx';

export default function SideNavMenu({
  parentId,
  menuDepth = 0,
  menu,
  routerLink,
}) {
  const [isActive] = useState(false);

  return (
    <ul
      className={cn(
        'lds-side-nav-menu',
        `depth-${menuDepth}`,
        {
          active: isActive,
        }
      )}
    >
      {
        menu.map((menuItem, idx) => (
          <MenuItem
            menuItem={menuItem}
            key={idx}
            parentId={parentId}
            menuDepth={menuDepth}
            routerLink={routerLink}
          />
        ))
      }
    </ul>
  );
}
